import { render, staticRenderFns } from "./GlobalDialogDownLoad.vue?vue&type=template&id=12401104&scoped=true"
import script from "./GlobalDialogDownLoad.vue?vue&type=script&lang=js"
export * from "./GlobalDialogDownLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12401104",
  null
  
)

export default component.exports